export default __webpack_public_path__ + "static/media/no-images-admin.311155af.svg";